export const SPINNER_LOADING = 'SPINNER_LOADING'
export default  {
    SPINNER_LOADING
}
